export default __webpack_public_path__ + "locales/si/SmartBanner.json?hash=377091e286782bf82536b77f3eaed0cf";